import * as actionTypes from "../actions/actionsTypes";

const initialState = {
  raceCalendarDates: {
    data: [],
  },
};

export const raceCalendarDatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RACE_CALENDAR_DATES:
      return {
        ...state,
        raceCalendarDates: action.payload,
      };
    default:
      return state;
  }
};
